import { toObject } from "../../core/utils";

class BusPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return toObject(data);
  }
}

export default BusPageTransform;



// WEBPACK FOOTER //
// ./src/pages/bus/bus.transforms.js